// Module
var code = "<select class=\"form-control input-sm\" ng-model=\"vm.model\" ng-options=\"mode.value as mode.name | translate for mode in vm.configModes\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.changed()\"> </select>";
// Exports
module.exports = code;